/* Memorial · fecha de entrega: Hoy / Mañana / Otra fecha (hora de Lima) */
(function () {
  'use strict';

  var CORTE_MIN = 17 * 60 + 30;   // hoy se recibe hasta las 5:30 p. m. (hora de Lima)
  var MARGEN_MIN = 90;            // un horario de hoy se ofrece si termina al menos 90 min después de ahora
  var TEXTO_CORTE = '5:30 p. m.';
  var WHATSAPP = '51922194330';
  var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'set', 'oct', 'nov', 'dic'];

  function ahora() {
    var ms = (typeof window.__mmAhora === 'number') ? window.__mmAhora : Date.now();
    var d = new Date(ms - 5 * 3600000); // Perú: UTC-5, sin horario de verano
    return { y: d.getUTCFullYear(), m: d.getUTCMonth(), d: d.getUTCDate(), min: d.getUTCHours() * 60 + d.getUTCMinutes() };
  }
  function suma(t, n) {
    var x = new Date(Date.UTC(t.y, t.m, t.d + n, 12));
    return { y: x.getUTCFullYear(), m: x.getUTCMonth(), d: x.getUTCDate(), dow: x.getUTCDay() };
  }
  function iso(o) { return o.y + '-' + ('0' + (o.m + 1)).slice(-2) + '-' + ('0' + o.d).slice(-2); }
  function etiqueta(o) { return DIAS[o.dow] + ' ' + o.d + ' ' + MESES[o.m]; }
  var DIAS_CFG = (window.MM_DIAS && typeof window.MM_DIAS.length === 'number') ? window.MM_DIAS : [];
  function dowDe(isoStr) { return new Date(isoStr + 'T12:00:00Z').getUTCDay(); }
  // Devuelve si ese día NO se hacen entregas: por defecto los domingos; el metaobjeto puede cerrar o abrir cualquier fecha
  function regla(isoStr) {
    var ent = null;
    DIAS_CFG.forEach(function (e) { if (e && e.f === isoStr) ent = e; });
    if (ent) return ent.a ? { cerrado: false } : { cerrado: true, mensaje: ent.m || 'No realizamos entregas ese día.' };
    if (dowDe(isoStr) === 0) return { cerrado: true, mensaje: 'Los domingos no realizamos entregas.' };
    return { cerrado: false };
  }
  function estado() {
    var t = ahora();
    var hoy = suma(t, 0), man = suma(t, 1);
    var hr = regla(iso(hoy)), mr = regla(iso(man));
    return { t: t, hoy: hoy, man: man, pas: suma(t, 2), hoyReg: hr, manReg: mr,
      hoyHora: t.min < CORTE_MIN, hoyOk: t.min < CORTE_MIN && !hr.cerrado, manOk: !mr.cerrado };
  }
  function proxima(E) {
    for (var n = E.hoyOk ? 0 : 1; n < 60; n++) {
      var o = suma(E.t, n);
      if (!regla(iso(o)).cerrado) return o;
    }
    return null;
  }
  function finHorario(txt) {
    var m = /\ba\s+(\d{1,2})\s*(am|pm)/i.exec(txt || '');
    if (!m) return null;
    var h = parseInt(m[1], 10) % 12;
    if (m[2].toLowerCase() === 'pm') h += 12;
    return h * 60;
  }
  function el(tag, clase, texto) { var e = document.createElement(tag); if (clase) e.className = clase; if (texto != null) e.textContent = texto; return e; }
  function evento(nombre, datos) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: nombre }; for (var k in datos) o[k] = datos[k];
    window.dataLayer.push(o);
  }

  function estilos() {
    if (document.getElementById('mm-fecha-css')) return;
    var s = document.createElement('style'); s.id = 'mm-fecha-css';
    s.textContent =
      '.fecha-horario-container{display:flex!important;flex-direction:column!important;gap:18px!important}' +
      '.fecha-horario-container>.fecha-seleccion,.fecha-horario-container>.horario-seleccion{width:100%!important;max-width:none!important;flex:1 1 auto!important}' +
      '.mm-corte{display:none!important}' +
      '.mm-dia{margin:6px 0 4px}' +
      '.mm-dia__botones{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px}' +
      '.mm-dia__btn{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;min-height:60px;padding:8px 6px;border-radius:12px;border:1px solid rgba(23,43,33,.3);background:#fff;color:#172B21;cursor:pointer;text-align:center}' +
      '.mm-dia__btn:hover:not([disabled]){border-color:#29371C}' +
      '.mm-dia__btn b{font-size:16px;font-weight:700;line-height:1.2}' +
      '.mm-dia__btn span{font-size:13px;line-height:1.2;color:#4a4a4a}' +
      '.mm-dia__btn[aria-pressed="true"]{background:#172B21;border-color:#172B21;color:#E5E1D1}' +
      '.mm-dia__btn[aria-pressed="true"] span{color:#E5E1D1}' +
      '.mm-dia__btn[disabled]{background:#f1f1ee;border-color:rgba(23,43,33,.15);color:#8a8a8a;cursor:not-allowed}' +
      '.mm-dia__btn[disabled] b{text-decoration:line-through}' +
      '.mm-dia__msg{margin:10px 0 0;padding:10px 12px;border-radius:10px;background:rgba(229,225,209,.6);border:1px solid rgba(23,43,33,.12);font-size:14px;line-height:1.45;color:#172B21}' +
      '.mm-dia__msg a{color:#172B21;font-weight:600;text-decoration:underline}' +
      '.mm-dia__nota{margin:8px 0 0;font-size:13px;line-height:1.4;color:#5a5a5a}' +
      '.mm-dia__cal{margin-top:10px}' +
      '.mm-dia__prox{margin-left:4px;padding:4px 12px;border-radius:999px;border:1px solid #172B21;background:#172B21;color:#E5E1D1;font-size:13px;cursor:pointer}' +
      '@media (max-width:480px){.mm-dia__btn b{font-size:15px}.mm-dia__btn span{font-size:12px}}';
    document.head.appendChild(s);
  }

  function iniciar(intento) {
    var f = document.querySelector('input[name="properties[Fecha]"]');
    if (!f) return;
    var fp = f._flatpickr;
    if (!fp) { if ((intento || 0) < 30) setTimeout(function () { iniciar((intento || 0) + 1); }, 150); return; }
    var caja = f.closest('.fecha-seleccion');
    var envoltorio = f.closest('.flatpickr-wrapper') || f.parentNode;
    if (!caja || caja.querySelector('.mm-dia')) return;
    estilos();

    var ui = el('div', 'mm-dia');
    var botones = el('div', 'mm-dia__botones');
    var bHoy = el('button', 'mm-dia__btn'), bMan = el('button', 'mm-dia__btn'), bOtra = el('button', 'mm-dia__btn');
    [bHoy, bMan, bOtra].forEach(function (b) { b.type = 'button'; b.setAttribute('aria-pressed', 'false'); botones.appendChild(b); });
    var msg = el('p', 'mm-dia__msg'); msg.setAttribute('role', 'status'); msg.hidden = true;
    var nota = el('p', 'mm-dia__nota');
    ui.appendChild(botones); ui.appendChild(msg); ui.appendChild(nota);
    var h5 = caja.querySelector('h5');
    caja.insertBefore(ui, h5 ? h5.nextSibling : caja.firstChild);
    envoltorio.classList.add('mm-dia__cal');
    envoltorio.hidden = true;
    caja.appendChild(envoltorio);

    var activo = null, avisoCerrado = false;

    function rellenar(b, titulo, sub) { b.textContent = ''; b.appendChild(el('b', null, titulo)); b.appendChild(el('span', null, sub)); }

    function filtrarHorarios(esHoy) {
      var sel = document.querySelector('select[name="properties[Horario]"]');
      if (!sel) return;
      var t = ahora();
      Array.prototype.forEach.call(sel.options, function (o) {
        if (!o.value) return;
        if (o.getAttribute('data-txt') == null) o.setAttribute('data-txt', o.textContent);
        var fin = finHorario(o.value);
        var fuera = esHoy && fin != null && (fin - t.min) < MARGEN_MIN;
        o.disabled = fuera;
        o.textContent = fuera ? (o.getAttribute('data-txt') + ' · no disponible hoy') : o.getAttribute('data-txt');
        if (fuera && o.selected) { sel.value = ''; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }

    function pintar() {
      var E = estado();
      rellenar(bHoy, 'Hoy', E.hoyOk ? etiqueta(E.hoy) : (E.hoyReg.cerrado ? 'Sin entregas' : 'Cerrado'));
      rellenar(bMan, 'Mañana', E.manOk ? etiqueta(E.man) : 'Sin entregas');
      rellenar(bOtra, 'Otra fecha', 'Calendario');
      bHoy.disabled = !E.hoyOk;
      bMan.disabled = !E.manOk;
      bHoy.setAttribute('aria-pressed', activo === 'hoy' ? 'true' : 'false');
      bMan.setAttribute('aria-pressed', activo === 'manana' ? 'true' : 'false');
      bOtra.setAttribute('aria-pressed', activo === 'otra' ? 'true' : 'false');
      envoltorio.hidden = activo !== 'otra';
      msg.textContent = '';
      var hayAviso = false;
      if (E.hoyReg.cerrado) {
        msg.appendChild(document.createTextNode((/\bhoy\b/i.test(E.hoyReg.mensaje) ? '' : 'Hoy: ') + E.hoyReg.mensaje + ' ')); hayAviso = true;
      } else if (!E.hoyHora) {
        msg.appendChild(document.createTextNode('Para entrega hoy, la compra debe hacerse antes de las ' + TEXTO_CORTE + ' Si es urgente, '));
        var a = el('a', null, 'escríbenos por WhatsApp');
        a.href = 'https://wa.me/' + WHATSAPP + '?text=' + encodeURIComponent('Hola, necesito un arreglo de condolencias con entrega hoy. ¿Tienen disponibilidad?');
        a.target = '_blank'; a.rel = 'noopener';
        msg.appendChild(a); msg.appendChild(document.createTextNode('. ')); hayAviso = true;
      }
      if (!E.manOk) { msg.appendChild(document.createTextNode((/mañana/i.test(E.manReg.mensaje) ? '' : 'Mañana: ') + E.manReg.mensaje + ' ')); hayAviso = true; }
      if (!E.hoyOk && !E.manOk) {
        var p = proxima(E);
        if (p) {
          msg.appendChild(document.createTextNode('Próxima fecha disponible: '));
          var bp = el('button', 'mm-dia__prox', etiqueta(p)); bp.type = 'button';
          bp.addEventListener('click', function () { fp.set('minDate', iso(E.hoy)); fp.setDate(iso(p), true); });
          msg.appendChild(bp);
        }
      } else if (!E.hoyOk && E.manOk) {
        msg.appendChild(document.createTextNode('Elige mañana u otra fecha.'));
      }
      msg.hidden = !hayAviso;
      nota.hidden = !E.hoyOk;
      nota.textContent = 'Compra antes de las ' + TEXTO_CORTE + ' y lo entregamos hoy.';
      if (!E.hoyOk && !avisoCerrado) { avisoCerrado = true; evento('mm_fecha_hoy_cerrado', { motivo: E.hoyReg.cerrado ? 'dia' : 'hora' }); }
    }

    function sincronizar() {
      var E = estado(), v = f.value;
      filtrarHorarios(v === iso(E.hoy));
      if (!v) { if (activo !== 'otra') activo = null; }
      else if (regla(v).cerrado) { fp.clear(); return; }
      else if (v === iso(E.hoy)) {
        if (!E.hoyOk) { fp.clear(); return; }
        activo = 'hoy';
      } else if (v === iso(E.man)) activo = 'manana';
      else activo = 'otra';
      pintar();
    }

    function elegir(clave) {
      var E = estado();
      if (clave === 'hoy' && !E.hoyOk) return;
      if (clave === 'manana' && !E.manOk) return;
      evento('mm_fecha_opcion', { opcion: clave });
      if (clave === 'otra') {
        activo = 'otra';
        fp.set('minDate', iso(E.pas));
        if (f.value && f.value < iso(E.pas)) fp.clear();
        pintar();
        fp.open();
        return;
      }
      fp.set('minDate', iso(E.hoy));
      fp.setDate(iso(clave === 'hoy' ? E.hoy : E.man), true);
    }

    bHoy.addEventListener('click', function () { elegir('hoy'); });
    bMan.addEventListener('click', function () { elegir('manana'); });
    bOtra.addEventListener('click', function () { elegir('otra'); });
    f.addEventListener('change', sincronizar);
    if (fp.config && fp.config.onOpen) fp.config.onOpen.push(function () { if (activo === 'otra') fp.set('minDate', iso(estado().pas)); });

    fp.set('disable', [function (d) { return regla(iso({ y: d.getFullYear(), m: d.getMonth(), d: d.getDate() })).cerrado; }]);
    fp.set('minDate', iso(estado().hoy));
    sincronizar();
    setInterval(sincronizar, 30000);
  }

  function arranque() { setTimeout(function () { iniciar(0); }, 60); }
  if (document.readyState !== 'loading') arranque(); else document.addEventListener('DOMContentLoaded', arranque);
})();
